import { type PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import {
  type CommonExpressPaymentMethod,
  type IPayPalPaymentMethod,
} from '@wix/cashier-core/dist/src/services/PaymentMethod/types';

/*
  Google pay
*/

export type GooglePayPaymentMethod = CommonExpressPaymentMethod & {
  [PaymentMethod.GooglePay]: {
    merchantCountry: string;
    allowCardNetworks: GooglePayCreditCardNetworks[];
    allowedAuthMethods: GooglePayAllowedAuthMethods[];
  };
};

// google.payments.api.CardParameters['allowedAuthMethods'];
export type GooglePayAllowedAuthMethods = 'PAN_ONLY' | 'CRYPTOGRAM_3DS';

// google.payments.api.CardParameters['allowedCardNetworks'];
export enum GooglePayCreditCardNetworks {
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  MasterCard = 'MASTERCARD',
  Visa = 'VISA',
  Electron = 'ELECTRON',
  Elo = 'ELO',
  EloDebit = 'ELO_DEBIT',
  Maestro = 'MAESTRO',
}

/*
  Apple pay
*/

export type ApplePayPaymentMethod = CommonExpressPaymentMethod & {
  [PaymentMethod.ApplePay]: {
    merchantCountry: string;
    supportedNetworks: ApplePayCreditCardNetworks[];
    merchantCapabilities: ApplePayJS.ApplePayMerchantCapability[];
  };
};

export enum ApplePayCreditCardNetworks {
  Amex = 'amex',
  CartesBancaires = 'cartesBancaires',
  ChinaUnionPay = 'chinaUnionPay',
  Discover = 'discover',
  Eftpos = 'eftpos',
  Electron = 'electron',
  Elo = 'elo',
  Interac = 'interac',
  Jcb = 'jcb',
  Mada = 'mada',
  Maestro = 'maestro',
  MasterCard = 'masterCard',
  PrivateLabel = 'privateLabel',
  Visa = 'visa',
  VPAY = 'vPay',
}

/*
  PayPal
*/
export type PayPalPaymentMethod = IPayPalPaymentMethod;

/*
  ExpressPaymentMethod
*/
export type ExpressPaymentMethod = GooglePayPaymentMethod | ApplePayPaymentMethod | PayPalPaymentMethod;
export type ExpressPaymentMethods = ExpressPaymentMethod[];
